import { ShoppingCart } from 'models/Product'
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query'
import { Api } from 'types/Api'
import { ApiClient } from 'services/ApiClient'
import { PatchShoppingCart } from './usePatchShoppingCart'
import { CookieKeys, getCookie, setCookie } from 'services/Cookies'
import { getClientId } from 'utils/getClientId'

export namespace PostShoppingCart {
  export type Response = ShoppingCart
  export type Variables = PatchShoppingCart.Variables
  export type Error = Api.Error
  export type Options = UseMutationOptions<Response, Error, Variables>
}

export const usePostShoppingCart = (options?: PostShoppingCart.Options) => {
  const clientId = getClientId()
  const queryClient = useQueryClient()

  const mutationFn = async (data: PostShoppingCart.Variables) => {
    return ApiClient.post<PostShoppingCart.Response>(`/v1/shopping-carts`, {
      data: { clientId, ...data },
    })
  }

  const mutation = useMutation<
    PostShoppingCart.Response,
    PostShoppingCart.Error,
    PostShoppingCart.Variables
  >(mutationFn, {
    ...options,
    onSuccess: (shoppingCart) => {
      const isLogged = getCookie(CookieKeys.SESSION)
      if (!isLogged) {
        setCookie(CookieKeys.GUEST_ID, shoppingCart.clientId)
      }

      queryClient.refetchQueries(['shoppingCart'])
      queryClient.resetQueries(['shoppingCart'])
    },
  })

  return { ...mutation, postShoppingCart: mutation.mutate }
}
